import { Component, OnInit, OnDestroy, Input, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import {  Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { FarmService } from "src/app/services/farm-service.service";
import { PhameeService } from "src/app/services/phamee.service";
import { environment } from "src/environments/environment";
import { ProcessService } from "src/app/services/process.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { CdkDrag, CdkDragDrop, CdkDragEnter, CdkDropList, moveItemInArray } from "@angular/cdk/drag-drop";
declare var $: any;
// import { Chart } from "chart.js";
// import Swiper from "swiper";

@Component({
  selector: "smart-plot-detail",
  templateUrl: "./plot-detail.component.html",
  styleUrls: ["./plot-detail.component.css", "../platform-color/platform-color.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlotDetailComponent implements OnInit, OnDestroy {
  sensorExpand: boolean = false;
  @Input() plotId: string;
  @Input() farmId: string;
  @Input() cropId: string;
  @Input() zoneId: string;
  liveView:boolean = false;
  URLUPLOAD: string = environment.URLUPLOAD;
  plot: any;

  controls: any = [];
  sensors: any = [];
  dataControl: any = [];
  dataSensor: any = [];
  dataSensorRealtime: any = [];
  orderSenser: any = [];

  datenow: any;
  userRole = sessionStorage.getItem("role");
  textControl: any;
  arrDataSensor: any;
  emoticon: string;
  iconPath: string;

  url: string =
    "https://www.dbismartfarm.com/dbi-livecam?bypassauth=M9ZAmv7bMGHjnFRXhDHghBT1im4SRJS3&cam_wfmcaddr=58:BF:25:82:E2:50";
  urlSafe: SafeResourceUrl;

  @ViewChild(CdkDropList) placeholder: CdkDropList;
  target: CdkDropList;
  targetIndex: number;
  source: CdkDropList;
  sourceIndex: number;
  
  isSensorSortable: boolean = false;
  isControlSortable: boolean = false;

  ///socket
  // arrDataUpdate: any = [];
  // arrLabelUpdate: any = [];
  // arrTargetUpdate: any = [];
  // arrDataTargetUpdate: any = [];
  // data: any;
  // lineChart: any = []; //ประกาศตัวแปรเก็บค่า
  // myChart: any = [];
  // chart: any;
  // alert: any = 0;
  // index: any = 0;

  // indexcheckchart: any = 0;
  // dropdownList: any = [];
  // selectedItems: any = [];
  // dropdownSettings: any = {};
  // datamutiSelect: any = [];
  // propry: any = [];
  // arrGroupSencor: any = [];
  // checksensor: any;
  // arrDate: any = [];
  // flgesensor: any = true;
  // indexchart: any = 10;

  constructor(
    private spinner: NgxSpinnerService,
    private farmService: FarmService,
    private phameeService: PhameeService,
    private processService: ProcessService,
    private router: Router,
    public sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef
  ) {
    this.target = null;
    this.source = null;
  }

  async ngOnInit() {
    if (
      this.farmId == "6089080fe02f000022000772" &&
      this.plotId == "608965f2e02f000022000777" &&
      this.cropId == "611b6e33df34f8005f1f80df" &&
      this.zoneId == "60890896e02f000022000773"
    ) {
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
      this.liveView = true;
    } else {
      this.liveView = false;
    }
    window.scroll(0, 0);
    let SocketObject = {
      plotId: this.plotId,
      type: "join",
    };
    this.processService.sendMsg(SocketObject);

    await this.getPlot();
    await this.getThingsById(false);
    await this.getDatenow();
    await this.getSocket();
    await this.getDesireControl();
  }

  ngAfterViewInit() {
    let phElement = this.placeholder.element.nativeElement;

    phElement.style.display = 'none';
    phElement.parentNode.removeChild(phElement);
  }

  ngAfterViewChecked() {
    this.detectChanges();
  }

  ngOnDestroy() {
    let SocketObject = {
      plotId: this.plotId,
      type: "leave",
    };

    this.processService.sendMsg(SocketObject);
    $("#setEmo").modal("hide");
    this.detectChanges();
  }

  async sortSensor(){

    if (!this.target) {
      return;
    }

    const phElement = this.placeholder.element.nativeElement;
    const parent = phElement.parentElement;

    phElement.style.display = 'none';

    parent.removeChild(phElement);
    parent.appendChild(phElement);
    parent.insertBefore(
      this.source.element.nativeElement,
      parent.children[this.sourceIndex]
    );

    this.target = null;
    this.source = null;

    if (this.sourceIndex !== this.targetIndex) {
      moveItemInArray(this.dataSensor, this.sourceIndex, this.targetIndex);

      await Promise.all(this.dataSensor.map(async (sensor, index)=>{
        let data = {
          org_id: sensor.org_id,
          child_org_id: sensor.child_org_id,
          thing_id: sensor.thing_id,
          thing_key: sensor.thing_key,
          farm_id: sensor.farm_id,
          plot_id: sensor.plot_id,
          sensor_bottom_border: sensor.sensor_bottom_border.toString(),
          sensor_top_border: sensor.sensor_top_border.toString(),
          sensor_id: sensor.sensor_id,
          sensor_img: sensor.sensor_img,
          sensor_max: sensor.sensor_max.toString(),
          sensor_min: sensor.sensor_min.toString(),
          sensor_name: sensor.sensor_name,
          sensor_type: sensor.sensor_type,
          sensor_unit: sensor.sensor_unit? sensor.sensor_unit: "null",
          sensor_desc: sensor.sensor_name,
          active: sensor.active,
          sensor_widget_staus: sensor.active? "Y": "N",
          type: sensor.type,
          coordinates:{
            map_point:{
              lat: parseFloat(sensor.coordinates.map_point.lat),
              lon: parseFloat(sensor.coordinates.map_point.lon),
            }
          },
          _id: sensor._id,
          order_by: index + 1,
          color: sensor.color,
          default: sensor.default,
          sensor_graph_staus: sensor.sensor_graph_staus,
          sensor_target_relay: sensor.sensor_target_relay,
          sensor_target_value: sensor.sensor_target_value,
          sensor_target_color: sensor.sensor_target_color
        }
        this.farmService.updateSensor(data).subscribe(res=>{
        });
      }));
    }
  }

  async sortControl(event: CdkDragDrop<string[]>){
    if(event.previousIndex != event.currentIndex){
      moveItemInArray(this.dataControl, event.previousIndex, event.currentIndex);

      await Promise.all(this.dataControl.map(async (control, index)=>{
        let data = {
          org_id: control.org_id,
          child_org_id: control.child_org_id,
          thing_id: control.thing_id,
          thing_key: control.thing_key,
          farm_id: control.farm_id,
          plot_id: control.plot_id,
          sensor_bottom_border: control.sensor_bottom_border.toString(),
          sensor_top_border: control.sensor_top_border.toString(),
          sensor_id: control.sensor_id,
          sensor_img: control.sensor_img,
          sensor_max: control.sensor_max.toString(),
          sensor_min: control.sensor_min.toString(),
          sensor_name: control.sensor_name,
          sensor_type: control.sensor_type,
          sensor_unit: control.sensor_unit? control.sensor_unit: "null",
          sensor_desc: control.sensor_name,
          active: control.active,
          sensor_widget_staus: control.active? "Y": "N",
          type: control.type,
          coordinates:{
            map_point:{
              lat: parseFloat(control.coordinates.map_point.lat),
              lon: parseFloat(control.coordinates.map_point.lon),
            }
          },
          _id: control._id,
          order_by: index + 1,
          color: control.color,
          default: control.default,
          sensor_graph_staus: control.sensor_graph_staus,
          sensor_target_relay: control.sensor_target_relay,
          sensor_target_value: control.sensor_target_value,
          sensor_target_color: control.sensor_target_color
        }
        this.farmService.updateSensor(data).subscribe(res=>{
        });
      }));
    }
  }

  cdkDropListEntered(e: CdkDragEnter) {
    const drag = e.item;
    const drop = e.container;

    if (drop === this.placeholder) {
      return true;
    }

    const phElement = this.placeholder.element.nativeElement;
    const sourceElement = drag.dropContainer.element.nativeElement;
    const dropElement = drop.element.nativeElement;

    const dragIndex = __indexOf(
      dropElement.parentElement.children,
      this.source ? phElement : sourceElement
    );
    const dropIndex = __indexOf(
      dropElement.parentElement.children,
      dropElement
    );

    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = drag.dropContainer;

      phElement.style.width = dropElement.clientWidth / 2 + 'px';
      phElement.style.height = dropElement.clientHeight / 1.8  + 'px';

      sourceElement.parentElement.removeChild(sourceElement);
    }

    this.targetIndex = dropIndex;
    this.target = drop;

    phElement.style.display = '';
    dropElement.parentElement.insertBefore(
      phElement,
      dropIndex > dragIndex ? dropElement.nextSibling : dropElement
    );

    requestAnimationFrame(() => {
      this.placeholder._dropListRef.enter(
        drag._dragRef,
        drag.element.nativeElement.offsetLeft,
        drag.element.nativeElement.offsetTop
      );
    });
  }

  async getDatenow() {
    const eventNow = new Date();
    const optionsNow = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    } as const;
    this.datenow = eventNow.toLocaleDateString("th-TH", optionsNow);
  }

  getTime(date) {
    const eventNow = new Date(date);
    const optionsNow = {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    } as const;

    return eventNow.toLocaleTimeString("th-TH", optionsNow);
  }
  getDateCardMobile(date) {
    const eventNow = new Date(date);
    const optionsNow = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    } as const;


    return eventNow.toLocaleDateString("th-TH", optionsNow) + " น.";
  }
  substrData(data, start, end) {
    if (data != "" && data != undefined) {
      if (data.length > end) {
        return data.substr(start, end) + "..";
      } else {
        return data;
      }
    } else {
      return "";
    }
  }
  async closeCrop() {
    this.phameeService
      .closeCrop(this.plotId, this.cropId)
      .subscribe(async (success) => {

        if (success.code == 200) {
          Swal.fire({
            title: "ดำเนินการเสร็จสิ้น",
            timer: 2000,
            icon: "success",
            timerProgressBar: true,
            showConfirmButton: false,
            allowOutsideClick: false,
            onClose: () => {
              this.router.navigate(["/dashboard"]);
            },
          });
        }
      });
  }
  async getPlot() {
    this.farmService
      .getPlotDetailByID(this.plotId)
      .subscribe(async (success) => {

        if (success.code == 200) {
          this.plot = success.data[0];
          let cropId = success.data[0].crop.cropId;
          this.iconPath = success.data[0].icon_path
            ? success.data[0].icon_path
            : `/assets/img/emoticon/`;
        }
      });
  }
  async getThingsById(isRefresh) {

    if (isRefresh) this.spinner.show();
    setTimeout(async () => {
      this.farmService
        .getThingById(this.farmId, this.plotId)
        .subscribe(async (success) => {

          if (success.code == 200) {

            this.controls = [];
            this.sensors = [];
            for (let i = 0; i < success.data.length; i++) {
              const element = success.data[i];

              this.controls = this.controls.concat(element.control);

              this.sensors = this.sensors.concat(element.sensor);
            }
            
            this.dataControl = this.controls.filter(control=> 
              control.active 
              && !['camera', 'video', 'image_capture'].includes(control.type)
            ).sort(function(a, b) {
              return a.order_by - b.order_by;
            });
            
            this.dataSensor = this.sensors.filter(sensor=> 
              sensor.active 
              && sensor.sensor_widget_staus == "Y" 
              && !['camera', 'video', 'image_capture'].includes(sensor.type)
            );
          }
        });
      if (isRefresh) this.spinner.hide();
    }, 500);
  }

  dateFormat(date) {
    var datenow = new Date(date);
    return moment(datenow, "YYYY-MM-DD HH:mm:ss", "Asia/Bangkok").format(
      "DD/MM/YYYY"
    );
  }
  closeModal() {
    $("#setControllabel").modal("hide");
    this.getThingsById(true);
  }
  async onLabelControl(data) {
    this.spinner.show();
    setTimeout(async () => {
      $("#setControllabel").modal("show");
      if (data.sensor_type_status == 0) {
        this.textControl =
          "คุณต้องการเปลี่ยนการทำงาน " +
          data.sensor_name +
          " เป็น AUTO ใช่หรือไม่";
      } else {
        this.textControl =
          "คุณต้องการเปลี่ยนการทำงาน " +
          data.sensor_name +
          " เป็น MANUAL ใช่หรือไม่";
      }
      this.arrDataSensor = data;
      this.spinner.hide();
    }, 1);
  }

  async onUpdateControl(arr) {

    if (arr.sensor_type_status == 1) {
      arr.sensor_type_status = 0;
      this.selectControl(arr);
    } else {
      arr.sensor_type_status = 0;
    }

    let data = {
      sensor_type_status: arr.sensor_type_status,
      thing_id: arr.thing_id,
      sensor_id: arr.sensor_id,
    };


    this.farmService
      .getUpdateControlbyId(data)
      .subscribe(async (success) => {

        if (success.code == 200) {

          $("#setControllabel").modal("hide");
        }
      });
  }

  async selectControl(arr) {

    let checked = $("#customSwitch" + arr.sensor_id+arr.thing_id).prop("checked");
    let ValueChecked = 0;
    if (checked == true) {
      ValueChecked = 1;
    } else {
      ValueChecked = 0;
    }
    await this.onUpdateControl(arr);

    let data = {
      ThingId: arr.thing_id,
      Control: arr.sensor_id,
      Value: ValueChecked,
    };
    this.farmService.getControlbyId(data).subscribe(async (success) => {

      if (success.code == 200) {

        if (success.data) {
          if (success.data.OperationStatus.Code == 20000) {
            Swal.fire({
              title: "ดำเนินการเสร็จสิ้น",
              timer: 2000,
              icon: "success",
              timerProgressBar: true,
              showConfirmButton: false,
              allowOutsideClick: false,
              onClose: () => {
                //this.spinner.hide();
              },
            });
          } else {
            Swal.fire({
              title: success.data.OperationStatus.description
                ? success.data.OperationStatus.description
                : "พบข้อผิดพลาด",
              timer: 2000,
              icon: "error",
              timerProgressBar: true,
              showConfirmButton: false,
              allowOutsideClick: false,
              onClose: () => {
                //this.spinner.hide();
              },
            });
            await this.getThingsById(true);
          }
        } else {
          Swal.fire({
            title: "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้",
            timer: 2000,
            icon: "error",
            timerProgressBar: true,
            showConfirmButton: false,
            allowOutsideClick: false,
            onClose: () => {
              //this.spinner.hide();
            },
          });
          await this.getThingsById(true);
        }
      }
    });
  }

  async getDesireControl() {
    
    this.processService.messages.subscribe(async (msg) => {
      if (msg.type == "ONOFF") {

        await this.dataControl.map((element, i) => {
          msg.data.forEach((data) => {
            if (element.sensor_id == data.sensor_id && data.thing_id == element.thing_id) {
              this.dataControl[i] = data;
            }
          });
        });
        await this.dataControl.sort(function(a, b) {
          return a.order_by - b.order_by;
        });

        this.dataControl.forEach((element) => {
          if (element.last_active_value == 1) {
            $("#customSwitch" + element.sensor_id+element.thing_id).prop("checked", true);
          } else {
            $("#customSwitch" + element.sensor_id+element.thing_id).prop("checked", false);
          }
        });
      }
    });
  }

  async getSocket() {
    // this.arrDataUpdate = [];
    // this.arrTargetUpdate = [];
    // this.arrLabelUpdate = [];

    this.processService.messages.subscribe(async (msg) => {
      // this.data = msg;
      // let arrSensor = [];
      if (msg.type == "RPT") {

        if (msg.code == 200) {
          await msg.data.forEach(async (element) => {
       
            if (element._id == this.farmId) {

              await element.Plot.forEach(async (elementp) => {
        
                if (elementp._id == this.plotId) {
                  this.emoticon = elementp.emo_status;
           
                  $("#emoImg").attr(
                    "src",
                    "." + this.iconPath + elementp.emo_status + ".png"
                  );

                  if (elementp.thing[0] != undefined) {

                    await this.getSensor(elementp.thing);


                    // this.getControl(elementp.thing);
     
                    // arrSensor = [];
                    // this.dataSensorRealtime.forEach((elementS) => {
                 
                    //   if (elementS.last_active_value == undefined) {
                    //     elementS.last_active_value = "0";
                    //   }

                    //   if (this.datamutiSelect.length > 0) {
                    //     var filtered = this.datamutiSelect.filter(function (
                    //       value,
                    //       index,
                    //       arr
                    //     ) {
                    //       return elementS._id == value.id;
                    //     });

                    //     if (filtered.length > 0) {
                    //       arrSensor.push({
                    //         id: elementS._id,
                    //         last_active_value: elementS.last_active_value,
                    //         lastValue: elementS.lastValue,
                    //         sensor_desc: elementS.sensor_desc,
                    //         sensor_target_value: elementS.sensor_target_value,
                    //         last_update: elementS.last_update,
                    //         last_active_date: elementS.last_active_date,
                    //         color: elementS.color,
                    //         sensor_target_color: elementS.sensor_target_color,
                    //       });
                    //     }
                    //   }
                    // });
                  }
                }
              });
            }
          });
        }
      }
      // this.propry = arrSensor;
      // this.arrGroupSencor = [];
      // let checksensor =
      //   sessionStorage.getItem("FlagSensor") != undefined &&
      //   sessionStorage.getItem("FlagSensor") == "true"
      //     ? true
      //     : false;
      // this.checksensor = checksensor;
      // let arrDataUpdate = [];
      // let arrTargetUpdate = [];
      // let arrLabelUpdate = [];

      // arrSensor.forEach((elementG, index) => {

      //   if (
      //     elementG.last_active_value == undefined ||
      //     elementG.last_active_value == "null"
      //   ) {
      //     elementG.last_active_value = "0";
      //   }

      //   arrDataUpdate.push(elementG.last_active_value);

      //   arrLabelUpdate.push(this.getTime(elementG.last_active_date));

      //   this.arrDataTargetUpdate.push(elementG.last_active_value);

      //   this.arrGroupSencor.push({
      //     label: elementG.sensor_desc,
      //     // position: "right",
      //     data: [elementG.last_active_value],
      //     fill: false,
      //     lineTension: 0.2,
      //     showLine: true,
      //     borderColor: elementG.color, // สีของเส้น
      //     backgroundColor: elementG.color,
      //     borderWidth: 1,
      //   });
      //   if (checksensor) {
      //     arrTargetUpdate.push(elementG.sensor_target_value);
      //     this.arrDataTargetUpdate.push(elementG.sensor_target_value);

      //     this.arrGroupSencor.push({
      //       label: elementG.sensor_desc,
      //       // position: "right",
      //       data: [elementG.sensor_target_value],
      //       fill: false,
      //       lineTension: 0.2,
      //       showLine: true,
      //       borderDash: [10, 5],
      //       borderColor: elementG.color, // สีของเส้น
      //       backgroundColor: elementG.color,
      //       borderWidth: 1,
      //     });
      //   }
      //   this.arrDate = arrLabelUpdate;
      // });

      // this.arrDataUpdate = arrDataUpdate;
      // this.arrTargetUpdate = arrTargetUpdate;
      // this.arrLabelUpdate = arrLabelUpdate;

      //if (msg.type == 'RPT') {
        // if (this.datamutiSelect.length > 0) {
        //   if (checksensor && this.flgesensor) {
        
        //     this.arrDate = [arrLabelUpdate[0]];
        //     this.Chart(this.arrGroupSencor, this.arrDate, msg.type);
        //     this.flgesensor = false;

        //     this.indexcheckchart = 0;
        //   } else if (!checksensor && this.flgesensor) {
        
        //     this.flgesensor = false;

        //     this.arrDate = [arrLabelUpdate[0]];
        //     this.Chart(this.arrGroupSencor, this.arrDate, msg.type);
        //     this.indexcheckchart = 0;
        //   } else {
        //     if (msg.type == "RPT") {
        //       this.updatechart(
        //         this.arrDataTargetUpdate,
        //         this.arrLabelUpdate,
        //         this.arrTargetUpdate
        //       );
        //     }
        //   }
        // }
      // }

      // this.arrDataTargetUpdate = [];
    });
  }

  async getSensor(data) {
    let arrSensor = [];
    await Promise.all(data.map(async (element)=>{
      await Promise.all(element.sensor.map(async (sensor)=>{
        if (sensor.active 
          && sensor.sensor_widget_staus == "Y" 
          && !['camera', 'video', 'image_capture'].includes(sensor.type)
        ) {

          arrSensor.push(sensor);
        }
      }));
    }));
    
    this.dataSensorRealtime = arrSensor;
    this.detectChanges();
    
    await Promise.all(this.dataSensor.map(async (sensor, index)=>{
      let color = "#f65a5a";
      let color_text = "#f65a5a";
      let color_card = true;
      let sensorInfo = this.dataSensorRealtime.find(item=> item._id == sensor._id);
      
      if(sensorInfo){
        if(sensorInfo.last_active_value >= sensorInfo.sensor_min && sensorInfo.last_active_value <= sensorInfo.sensor_max){
          color = "#73dd84"
          color_text = "#00000"
          color_card = false;
        }
        this.dataSensor[index] = {
          ...this.dataSensor[index],
          last_active_value: sensorInfo.last_active_value,
          color: color,
          color_text: color_text,
          color_card: color_card,
        };
      }
    }));
  }

  detectChanges(){
    this.cdRef.detectChanges();
  }

  scheduleDetail(data) {
    this.router.navigate(["/schedule-detail"], {
      queryParams: {
        farmId: this.farmId,
        plotId: this.plotId,
        cropId: this.cropId,
        zoneId: this.zoneId,
        sensorId: data.sensor_id,
        thingId: data.thing_id,
      },
    }).then(() => { window.location.reload() });
  }

  // Chart(data, dateValue, sensor_type) {
  //   if (sensor_type == "RPT") {
  //     $("#sensor_chart").replaceWith(
  //       $('<canvas id="sensor_chart" width=100 height=50></canvas>')
  //     );

  //     this.lineChart = new Chart("sensor_chart", {
  //       // สร้าง object และใช้ชื่อ id lineChart ในการอ้างอิงเพื่อนำมาเเสดงผล
  //       type: "line", // ใช้ชนิดแผนภูมิแบบเส้นสามารถเปลี่ยนชิดได้
  //       data: {
  //         // ข้อมูลภายในแผนภูมิแบบเส้น
  //         labels: dateValue, // ชื่อของข้อมูลในแนวแกน x
  //         datasets: data,
  //       },
  //       options: {
  //         title: {
  //           // ข้อความที่อยู่ด้านบนของแผนภูมิ
  //           // text: "Total members and Active members",
  //           display: false,
  //         },
  //         legend: {
  //           display: false,
  //         },
  //         showLines: false,
  //         scales: {
  //           yAxes: [
  //             {
  //               ticks: {
  //                 beginAtZero: true,
  //               },
  //               time: {
  //                 stepSize: 10,
  //               },
  //             },
  //           ],
  //         },
  //         tooltips: {
  //           mode: "index",
  //           intersect: false,
  //         },
  //         hover: {
  //           mode: "nearest",
  //           intersect: false,
  //         },
  //       },
  //     });
  //   }
  // }

  // updatechart(data, label, target) {

  //   this.indexcheckchart++;
  //   if (window.matchMedia("(max-width: 494px)").matches) {
  //     this.indexchart = 5;
  //   }
  //   if (this.indexcheckchart > this.indexchart) {
  //     //ทำลาย กราฟเดิม++--
  //     this.lineChart.config.data.datasets.forEach((dataset, index) => {
  //       dataset.data.push(data[index]);
  //       dataset.data.splice(0, 1);
  //     });
  //     this.lineChart.config.data.labels.push(label[0]);
  //     this.lineChart.config.data.labels.splice(0, 1);
  //   } else {
  //     for (
  //       let index = 0;
  //       index < this.lineChart.data.datasets.length;
  //       index++
  //     ) {
  //       const dataset = this.lineChart.data.datasets[index];
  //       dataset.data.push(data[index]);
  //     }
  //     this.lineChart.data.labels.push(label[0]);
  //   }

  //   this.lineChart.update();

  //   data = [];
  // }

  // getSlide() {
  //   if (window.matchMedia("(max-width: 768px)").matches) {
  //     new Swiper(".swiper-container", {
  //       slidesPerView: 3,
  //       spaceBetween: 5,
  //       speed: 10,
  //       freeMode: true,
  //       pagination: {
  //         el: ".swiper-pagination",
  //         type: "bullets",
  //         dynamicBullets: true,
  //       },
  //     });
  //   } else {
  //     new Swiper(".swiper-container", {
  //       slidesPerView: 6,
  //       spaceBetween: 5,
  //       speed: 10,
  //       // freeMode: true,
  //       pagination: {
  //         el: ".swiper-pagination",
  //         type: "bullets",
  //         dynamicBullets: true,
  //       },
  //     });
  //   }
  // }
}

function __indexOf(collection, node) {
  return Array.prototype.indexOf.call(collection, node);
}
